import { outsourceInvoiceLoaders } from './outsourceInvoices';
import { packageLoaders } from './packages';
import { projectInvoiceLoaders } from './projectInvoices';
import { invoiceLoaders as actualInvoiceLoaders } from './invoices';
import { invoiceProjectsLoaders } from './projects';
import { quotationRequestLoaders } from './quotationRequests';

export const invoiceLoaders = {
  ...packageLoaders,

  ...outsourceInvoiceLoaders,

  ...projectInvoiceLoaders,

  ...actualInvoiceLoaders,

  ...invoiceProjectsLoaders,

  ...quotationRequestLoaders,
};
